import { Component, Inject, Input, OnInit, ViewChild } from '@angular/core';
import { NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss'],
})
export class ModalComponent implements OnInit {
  @Input() name: any;
  @ViewChild('openModal') openModal: any;
  @Input() set showPopup(value: any) {
    // console.log(value, 'mdalllllll', this.openModal,value?.size)
    if (value != undefined) {
      if (value?.size) {
        if (value?.check && this.openModal) {
          this.modalService.open(this.openModal, {
            size: value?.size,
            backdrop: 'static',
            windowClass: value?.windowClass || '',
            keyboard: false,
          });
        } else if (value?.check == false) {
          this.modalService.dismissAll(this.openModal);
        }
      } else {
        if (value && this.openModal) {
          //  let out =  setTimeout(() => {
          //     clearTimeout(out);
          this.modalService.open(this.openModal, {
            size: 'md',
            backdrop: 'static',
            windowClass: 'model_width_set',
            keyboard: false,
          });
          // }, 100);
        } else if (value == false) {
          this.modalService.dismissAll(this.openModal);
        }
      }
    }
  }

  constructor(
    private modalService: NgbModal,
    public activeModal: NgbActiveModal,
  ) {}
  ngOnInit(): void {
    // console.log(this.openModal)
  }
  ngAfterViewInit() {
    // console.log(this.openModal)
  }
  dismissAll() {
    this.modalService.dismissAll(this.openModal);
  }
}

@Component({
  selector: 'app-modal-staked',
  templateUrl: './stakedmodal.component.html',
})
export class NgbdModal2Content {
  ref: any;
  @ViewChild('openChildModal') openChildModal: any;
  @Input() set showChildPopup(val: any) {
    if (val) {
      this.ref = this.modalService.open(this.openChildModal, {
        size: 'md',
        backdrop: 'static',
      });
    } else {
      this.ref && this.ref.close();
    }
  }

  constructor(
    private modalService: NgbModal,
    public activeModal: NgbActiveModal,
  ) {}
}
